import { Injectable } from '@angular/core';
import {concentrador} from '../models/concentrador';
import {HttpClientService} from "./http-client.service";
import {HttpParams} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ConcentradorService {

  private concentradorToEdit: concentrador;

  constructor(private http: HttpClientService) { }

  public getAll() {
    return this.http.get('/concentrador/getall');
  }

  public getByIdProyecto(idProyecto: string) {
    let params = new HttpParams().set("idProyecto",idProyecto);
    return this.http.getWithParams('/concentrador/getbyidproyecto', params);
  }

  public getByIdEmpresa(idEmpresa: string) {
    let params = new HttpParams().set("idEmpresa",idEmpresa);
    return this.http.getWithParams('/concentrador/getbyidempresa', params);
  }

  public setConcentradorToEdit(concentrador: concentrador) {
    this.concentradorToEdit = concentrador;
  }

  public getConcentradorToEdit() {
    return this.concentradorToEdit;
  }

  public infoUpdate(idDispositivo: string, nombre: string, idProyecto: string, idPlano: string, idZona: string,
                    idConcentradorMantenimiento: string, activo: boolean) {
    let body =
      {
        "idDispositivo": idDispositivo,
        "nombre": nombre,
        "idProyecto": idProyecto,
        "idPlano": idPlano,
        "idZona": idZona,
        "idConcentradorMantenimiento": idConcentradorMantenimiento,
        "activo": activo
      };
    return this.http.patch('/concentrador/infoupdate', body);
  }

  public delete(idDispositivo: string) {
    let body =
      {
        "idDispositivo": idDispositivo
      };
    return this.http.post('/concentrador/delete', body);
  }

}
